import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const LongDateInput = React.forwardRef(({ value, onClick, onChange, className }, ref) => (
    <input
        ref={ref}
        value={String(value || '').replace(/\bSep\b/, 'Sept')}
        onClick={onClick}
        onChange={onChange}
        className={className}
        readOnly
    />
));

const MyCalendar = ({ startDate, setStartDate, errors = [], name = '', errorMessage = '', longDate = false, disabled = false }) => {

    return (<div>
        <DatePicker
            selected={startDate}
            disabled={disabled}
            dateFormat={'dd/MM/yyyy'}
            onChange={(date) => setStartDate(date)}
            className={errors.includes(name) ? 'error' : ''}
            {...(longDate ? {
                dateFormat: 'EEEE, d MMM yyyy',
                customInput: <LongDateInput />,
            } : {})}
        />
        {errorMessage && <p style={{ margin: 0, fontSize: '13px', color: 'red' }}>{errorMessage}</p>}
    </div>);
}

export default MyCalendar
